import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class MobileFilesItem {
    ID: number;
    Public: number;
    Title: string;
    UUID: string;
    FileName: string;
    URL: string;
    CreatedDate: Date;
    ThumbnailURL: string;
    LicenseID: number;
    DeviceID: string;
    Source: string;
    MemberID: number;
    LicenseKey: string;

    public static FixDates(item: MobileFilesItem) {
        item.CreatedDate = new Date(item.CreatedDate);
    }

}

export class MobileFilesItemArray extends Array<MobileFilesItem> {
    public LastSort = new SortItem;

    constructor(...items: MobileFilesItem[]) {
        super(...items);
        Object.setPrototypeOf(this, MobileFilesItemArray.prototype);
    }

    public static FixDates(item: MobileFilesItemArray) {
        item.forEach(x => MobileFilesItem.FixDates(x));
    }


}
